export default __webpack_public_path__ + "static/media/redeemed_unlocked_rewards.f4246a66.png";